"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

require("../../assets/css/components/table/TableHeader.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//todo:adicionar props de abreviação
var TableHeader = function (_React$Component) {
    _inherits(TableHeader, _React$Component);

    function TableHeader() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, TableHeader);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TableHeader.__proto__ || Object.getPrototypeOf(TableHeader)).call.apply(_ref, [this].concat(args))), _this), _this.direction = function (target, sort) {
            var direction = sort.ascending ? "desc" : "asc";

            sort.direction = direction;
            target.className += direction;
        }, _this.onSort = function (event) {

            var sorting = false;
            var target = event.target;
            var listSort = _this.props.sorted !== null ? _this.props.sorted : [];

            target.className = 'sorted ';

            listSort.forEach(function (e, i) {

                if (target.id === _this.props.sorted[i].property) {
                    sorting = true;

                    if (listSort[i].direction === 'DESC') listSort.splice(i, 1);else _this.direction(target, e);
                }
            });

            if (!sorting) {
                target.className += 'asc';
                listSort.push({ property: target.id, direction: 'asc' });
            }

            _this.props.onSort(listSort);
        }, _this.getHead = function () {
            return _react2.default.createElement(
                "thead",
                null,
                _react2.default.createElement(
                    "tr",
                    null,
                    _this.props.data[0].props.children.length ? _this.props.data[0].props.children.map(function (row) {
                        return _this.getHeadColumn(row.props);
                    }) : _this.getHeadColumn(_this.props.data[0].props.children.props)
                )
            );
        }, _this.getHeadColumn = function (props) {
            return _react2.default.createElement(
                "th",
                { key: props.headers, className: (props.sorted ? 'sorted ' : '') + (props.action ? "table-actions " : "") + (props.className || ""),
                    id: props.headers,
                    onClick: props.sorted ? _this.onSort : '', scope: "col" },
                props.action ? "Ações" : props.label
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TableHeader, [{
        key: "render",
        value: function render() {
            return this.getHead();
        }
    }]);

    return TableHeader;
}(_react2.default.Component);

exports.default = TableHeader;


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/table/TableHeader.js
// module id = 599
// module chunks = 0